import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self, ViewChild } from '@angular/core'
import { FormGroupDirective, NgControl } from '@angular/forms'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
    selector: 'superflex-chips',
    template:`
        <label for="controlchip"> {{ label }} </label>
        <p-chips
            [formControl]='ngControl.control'
            [class.p-inputwrapper-filled]="filled"
            separator=",">
        </p-chips>
        <app-error [input]="ngControl.control" [form]="form" ></app-error>
    `,
    styleUrls: ['./chips.component.scss'],
    host: {'class': 'p-field'}
})
export class ChipsComponent implements OnInit, OnDestroy {

    @Input() isDisabled: boolean = false
    @Input() label: string = ''
    private _filled = false
    private unsubscribe$ = new Subject<void>()

    @Input() optionLabel = '';
    @Input() optionValue = '';

    @Input() placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    public checked: boolean;
    public focused: boolean;

    form!: FormGroupDirective;

    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {
        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }
    }

    public onModelTouched = () => {/** */ };

    ngOnInit(): void {
        this.ngControl.control.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
             this._filled = value? true : false
        })
    }

    writeValue(): void {/** */}
    registerOnChange(): void {/** */}
    registerOnTouched(): void {/** */}
    setDisabledState?(): void {/** */}

    get filled(){ return this._filled}

    ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }
    
    getPlaceholderPrefix(): string {
        return this.isDisabled ? '' : 'FORM_ERRORS.placeholder';
    }
}
